import { createFileRoute } from '@tanstack/react-router';

type Search = {
  from?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/phone/phone-tree-call-volume-all')({
  staticData: { team: 'analytics' },
  validateSearch: (search: Search) => {
    return {
      from: search.from,
    };
  },
});
